import React from 'react'
import Localizations from './containers/Localizations'
import './styles.scss'

const MainscreenLists = () => {
  return <Localizations />
}
export default MainscreenLists
